<template lang="pug">
  v-dialog(
    v-model="active"
    persistent
    width="400"
  )
    v-card(:loading="loading")
      v-card-title
        | New Keyword

      v-card-text
        v-layout(column)
          v-flex
            v-select(
              label="Math type"
              v-model="form.type"
              :items="optMatchTypes"
            )
            v-textarea(
              label="Keywords"
              v-model="form.keywords"
              @keydown.enter="doModifyKeywords"
            )

      v-card-actions.pa-3
        v-layout
          v-flex(xs6)
            v-btn(block color="green" @click="doSubmit") Submit
          v-flex(xs6)
            v-btn(block @click="active = false") Close
</template>

<script>
import ads from '@/services/googles/ads'

const EXACT = 'EXACT'
const BROAD = 'BROAD'
const FORM_DEFAULT = {
  type: EXACT,
  keywords: ''
}

export default {
  props: {
    customerId: [String, Number],
    adGroupId: [String, Number]
  },
  data () {
    return {
      active: false,
      loading: false,
      form: Object.assign({}, FORM_DEFAULT),
      optMatchTypes: [
        { text: 'Exact match', value: EXACT },
        { text: 'Broad modify match', value: BROAD }
      ]
    }
  },
  mounted () {
  },
  methods: {
    show () {
      this.active = true
      this.loading = false
      this.form = Object.assign({}, FORM_DEFAULT)
    },
    hide () {
      this.active = false
    },
    doModifyKeywords () {
      switch (this.form.type) {
        case EXACT:
          this.form.keywords = this.form.keywords
            .replace(/([[\]])/mg, '')
            .replace(/(\b.+\b)/mg, '[$1]')
          break
        case BROAD:
          this.form.keywords = this.form.keywords
            .replace(/([ +]+)/mg, ' ')
            .replace(/(\b\w+\b)/mg, '+$1')
            .replace(/(^ \+)/mg, '+')
          break
      }
    },
    doCreateAdGroupKeywords () {
      const texts = this.form.keywords.split('\n')
      const creates = texts
        .filter(t => t)
        .map(text => ({
          ad_group: `customers/${this.customerId}/adGroups/${this.adGroupId}`,
          keyword: {
            text: text,
            match_type: this.form.type
          }
        }))
      return ads.addAdGroupKeyword(this.customerId, creates)
    },
    async doSubmit () {
      this.loading = true
      this.doModifyKeywords()
      await this.doCreateAdGroupKeywords()

      this.hide()
      this.$emit('complele', true)
    }
  }
}
</script>
